import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import Routes from "./Routes/Routes";

function App() {
  return <Routes />;
}

export default App;
